import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m12 12.475 1.9 1.15a.46.46 0 0 0 .55-.012.45.45 0 0 0 .2-.513l-.5-2.175 1.7-1.475a.48.48 0 0 0 .15-.537q-.1-.313-.45-.338L13.325 8.4l-.875-2.05a.45.45 0 0 0-.45-.3.45.45 0 0 0-.45.3l-.875 2.05-2.225.175q-.35.026-.45.338a.48.48 0 0 0 .15.537l1.7 1.475-.5 2.175a.45.45 0 0 0 .2.513.46.46 0 0 0 .55.012zM6 18l-2.3 2.3q-.476.475-1.088.212Q2 20.25 2 19.575V4q0-.824.587-1.413A1.93 1.93 0 0 1 4 2h16q.824 0 1.413.587.586.589.587 1.413v12q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm-.85-2H20V4H4v13.125z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }